import React from 'react';
import arrow from '../../../../../../assets/icons/arrow-red.svg';
import { Text, Icon, Block } from '../../../../../components';
import { CloseButton } from '../../Modal/Modal';

const Back = (props: any) => {
  const { onClick, fontSize } = props;

  return (
    <>
      <CloseButton
        type="button"
        data-testid="cmp-buttom-back-refactor"
        onClick={onClick}
        padding="0px 12px 0px 8px"
      >
        <Block
          customized
          maxWidth="40px"
          height="40px"
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="row"
        >
          <Icon
            customized
            maxWidth="16px"
            height="16px"
            margin="0px 14.42px 0px 0px"
          >
            <img src={arrow} alt="Categorías" />
          </Icon>
        </Block>
        <Text fontSize={fontSize ?? '12px'} lineHeight="16px" fontWeight="700">
          Atrás
        </Text>
      </CloseButton>
      {/* <IElement
        maxWidth="81px"
        minWidth="81px"
        width="auto"
        customized
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexDirection="row"
        onClick={onClick}
        cursor="pointer"
        padding="0px 12px 0px 8px"
        borderRadius="4px"
        bkgColorEnabled="none"
        bkgColorHover="#FED4D6"
        bkgColorFocus="#FDADB3"
        bkgColorPressed="#FDADB3"
      >
        <Block
          customized
          maxWidth="40px"
          height="40px"
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="row"
        >
          <Icon
            customized
            maxWidth="16px"
            height="16px"
            margin="0px 14.42px 0px 0px"
          >
            <img> src={arrow} alt="Categorías" />
          </Icon>
        </Block>
        <Text fontSize="12px" lineHeight="16px" fontWeight="700">
          Atrás
        </Text>
      </IElement> */}
    </>
  );
};

export default Back;
